import React from 'react';
import styles from './Select.Footer.scss';
export var SelectFooter = function SelectFooter(props) {
  return React.createElement("div", {
    className: styles.footer
  }, props.children);
};
SelectFooter.displayName = 'Select.Footer';
export function isSelectFooter(element) {
  return element && element.type.displayName === SelectFooter.displayName;
}